export const batcher = (onFlush: () => void) => {
  let token: any
  const getWait = () => {
    clearTimeout(token)
    token = setTimeout(onFlush, 10)
  }
  getWait()
  return getWait
}
